// 富文本
import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'
import 'quill/dist/quill.bubble.css'
// quill-editor样式修补
import './quill-editor.less'

import QuillEditor from './quill-editor'
export default QuillEditor